"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)

var GlobalEvent_1 = require("./GlobalEvent");

exports.GlobalEvent = GlobalEvent_1.GlobalEvent; // @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })

var globalEvents = require("./globalEvents");

exports.globalEvents = globalEvents;